import React, {useEffect, useState} from "react";
import {Divider} from "primereact/divider";
import {Avatar} from "primereact/avatar";
import {useNavigate} from "react-router-dom";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import SingleCharInput from "../components/SingleCharInput";
import axios from "axios";
import Config from "../config";
import {types, useUser} from "./UserContext";
import {useStorage} from "../hooks/useStorage";
import config from "../config";
import "./index.css";
import {Password} from "primereact/password";
import {farsiDigitsToInt} from "../utils/functions";
import Kian from "../Kian";

import * as Configs from "../config";
import {useTokenEntityObject, useAuth} from "../dynamic365";
import Contact from "../dynamic365/entities/Contact";
import {Pencil} from "../icons";
import Account from "../dynamic365/entities/Account";
import {Captcha} from "primereact/captcha";
import {usePortalConfig} from "../dynamic365/entities/PortalConfig";

function CardHeader() {
    return (
        <div className="flex justify-content-center text-center bg-signin pt-6">
            {/*<Avatar className="w-12rem h-auto" image={process.env.PUBLIC_URL+"/assets/images/wall-bill3x.png"}/>*/}
            <h1 className="yekan-bakh-font text-primary-500">کیان پرداز هوشمند</h1>
        </div>
    )

}

function LoginPhoneNumber({setMobileNumber, mobileNumber, setCurrentComponent, setOperation}){
    const navigate = useNavigate();
    const contactEntity = useTokenEntityObject(Contact());
    const accountEntity = useTokenEntityObject(Account());
    const auth = useAuth();
    const user = useUser();
    let [mobileNumberErr, setMobileNumberErr] = useState({show:false, msg:'لطفا شماره موبایل خود را وارد کنید'});
    let [password, setPassword] = useState();
    let [passwordErr, setPasswordErr] = useState({show:false, msg:'لطفا رمز عبور را وارد کنید'});
    let [serverErr, setServerErr] = useState();
    let [loginLoading, setLoginLoading] = useState(false);
    let [requestCodeLoading, setRequestCodeLoading] = useState(false);
    const [captchaResponse, setCaptchaResponse] = useState(true);

    const{setUser} = useStorage();

    const login = ()=>{
        mobileNumber = farsiDigitsToInt(mobileNumber);

        if (!Configs.MOBILE_FORMAT_REGEX.test("0"+mobileNumber)){
            setMobileNumberErr({...mobileNumberErr, show: true});
            return;
        }
        if (!password){
            setPasswordErr({...passwordErr, show: true});
            return;
        }
        setLoginLoading(true);
        auth.login_phone_number({
            bodyData:{
                Username:"+98"+mobileNumber,
                Password:password
            },
            onResult:(token)=>{
                // console.log(token)
                fetchUser(token)
            },
            onError:(e)=>{
                setServerErr(e.response.data);
                // console.log(e);
                setLoginLoading(false);
            }
        })
    }

    const requestCode = ()=>{
        mobileNumber = farsiDigitsToInt(mobileNumber);

        if (!Configs.MOBILE_FORMAT_REGEX.test("0"+mobileNumber)){
            setMobileNumberErr({...mobileNumberErr, show: true});
            return;
        }
        setRequestCodeLoading(true);

        auth.request_code({
            bodyData:{
                Username:"+98"+mobileNumber
            },
            onResult:(data)=>{
                setRequestCodeLoading(false);
                setCurrentComponent("VERIFY_CODE");
                setOperation("LOGIN");
                // console.log(data);
            },
            onError:(e)=>{
                setServerErr(e.response.data);
                // console.log(e);
                setRequestCodeLoading(false);
            }
        })
    }

    const fetchUser=(token)=>{
        contactEntity.fetch({
            token,
            filters:{contactid:"$contactId"},
            onResult:({data:{value}})=>{
                setLoginLoading(false);
                let userData = {token, ...value[0]}
                // console.log(userData)
                fetchAccount(userData);
            }
        })
    }

    const fetchAccount = (userData)=>{
        let fetchBody = `<fetch >
                          <entity name="contact">
                            <filter>
                              <condition attribute="contactid" operator="eq" value="{${userData.contactid}}" />
                            </filter>
                            <link-entity name="account" from="accountid" to="parentcustomerid" alias="Account">
                              <attribute name="name" alias="Name" />
                              <attribute name="accountid" alias="AccountId" />
                            </link-entity>
                          </entity>
                        </fetch>`;
        // console.log(fetchBody)
        contactEntity.fetch({
            token:userData.token,
            fetchBody,
            onResult:({data:{value}})=>{
                // console.log(value)
                if (value.length>0){
                    userData = {...userData, companies:value, account:value[0], customerid:value[0].AccountId}
                    fetchAccountChildren(userData, value[0].AccountId)
                }
                else {
                    setUser(userData);
                    user.dispatch({type:types.SET_USER_DATA, userData});
                    navigate("/");
                }

            },
            onError:(e)=>{
                // console.log(e)
            },
        })
    }

    const fetchAccountChildren = (userData, accountId)=>{
        let fetchBody = `<fetch >
                          <entity name="account">
                            <attribute name="name" alias="Name" />
                            <filter>
                              <condition attribute="parentaccountid" operator="eq" value="${accountId}" />
                            </filter>
                          </entity>
                        </fetch>`;

        accountEntity.fetch({
            token:userData.token,
            fetchBody,
            onResult:({data:{value}})=>{
                // console.log(value);
                userData = {...userData, companies:[...userData.companies, ...value]}
                // console.log(userData)
                setUser(userData);
                user.dispatch({type:types.SET_USER_DATA, userData});
                navigate("/");
            },
            onError:(e)=>{
                // console.log(e)
            },
        })
    }

    return(
        <div>
            <CardHeader/>
            <div className="flex flex-column justify-content-center align-items-center w-full p-6 lg:p-8">
                <div className="font-bold flex gap-2 align-items-center pb-3 justify-content-start w-full">
                    <span>ورود</span>
                    {/*<span>|</span>*/}
                    {/*<span>ثبت نام</span>*/}
                </div>

                <form className="w-full " onSubmit={()=>{login()}}>
                    <div className="flex flex-column justify-content-start w-full">
                        <span className="text-xs">لطفا شماره موبایل خود را وارد کنید.</span>
                        <div className="field">
                            <InputText inputMode="tel" maxLength={11} value={mobileNumber} onChange={(e)=>{setMobileNumber(e.target.value); setMobileNumberErr({...mobileNumberErr, show:false})}} className={`text-center w-full border-round-xl bg-gray-100 shadow-none border-none ${mobileNumberErr.show && 'border-1 p-invalid'}`}/>
                            <small className={`block text-xs ${mobileNumberErr.show && "text-red-500"}`}>{!mobileNumberErr.show?"لطفا شماره موبایلی که بر روی آن واتس اپ نصب دارید را وارد نمایید.":"شماره موبایل وارد شده صحیح نیست"}</small>
                        </div>
                    </div>

                    <div className="flex flex-column justify-content-start w-full">
                        <span className="text-xs">رمز عبور به برنامه</span>
                        <div className="field">
                            <Password feedback={false} value={password} onChange={(e)=>{setPassword(e.target.value); setPasswordErr({...passwordErr, show:false})}} toggleMask className="w-full" inputClassName={`text-center w-full border-round-xl bg-gray-100 shadow-none border-none ${passwordErr.show && 'border-1 p-invalid'}`}/>
                            {passwordErr.show && <small className={`block text-xs text-red-500`}>لطفا رمز عبور را وارد کنید</small>}
                        </div>
                    </div>
                    {
                        captchaResponse?(
                            <div className="flex gap-2 align-items-center w-full">
                                <Button type="submit" className="flex-grow-1 border-round-lg" loading={loginLoading} label="ورود" onClick={()=>{login()}}/>
                                <Button className="p-button-outlined border-round-lg white-space-nowrap" loading={requestCodeLoading} label="دریافت کد فعال‌سازی" onClick={()=>{requestCode()}}/>
                            </div>
                        ):(
                            <Captcha siteKey="6Lf8UdkUAAAAABtUy2dbFuYS2nZN_aJE3WQDORdm" onResponse={()=>{setCaptchaResponse(true)}}/>
                        )
                    }
                </form>

                <span className={`pt-3 ${serverErr && 'p-error block'}`}>{serverErr}</span>

            </div>
        </div>
    )
}

function VerifyCode({mobileNumber, operation, setCurrentComponent}) {
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [serverErr, setServerErr] = useState();
    const navigate = useNavigate();
    let {setUser} = useStorage();
    const user  = useUser();
    const auth = useAuth();
    const contactEntity = useTokenEntityObject(Contact());
    const accountEntity = useTokenEntityObject(Account());

    const [shomarandeh, setShomarandeh] = useState(110);
    useEffect(()=>{
        shomarandeh > 0 && setTimeout(()=>{setShomarandeh(shomarandeh-1)},1000)
        // console.log(shomarandeh)
    },[shomarandeh]);
    const retryText = () => {
        let minutes=parseInt(shomarandeh/60);
        let seconds=parseInt(shomarandeh%60);
        return shomarandeh>0 ? `${minutes}:${seconds}` : `ارسال مجدد کد تایید`
    }
    const requestCode = ()=>{
        mobileNumber = farsiDigitsToInt(mobileNumber);

        if (!Configs.MOBILE_FORMAT_REGEX.test("0"+mobileNumber)){
            return;
        }

        auth.request_code({
            bodyData:{
                Username:"+98"+mobileNumber
            },
            onError:(e)=>{
                setServerErr(e.response.data);
            }
        })
    }

    const verify = (verifyCode)=>{
        mobileNumber = farsiDigitsToInt(mobileNumber);

        if (!Configs.MOBILE_FORMAT_REGEX.test("0"+mobileNumber)){
            return;
        }
        setVerifyLoading(true);
        auth.verification({
            bodyData:{
                Username:"+98"+mobileNumber,
                VerifyCode: verifyCode
            },
            onResult:(token)=>{
                fetchUser(token);
                // console.log(token)
                // contactEntity.fetch({
                //     token,
                //     filters:{contactid:"$contactId"},
                //     onResult:({data:{value}})=>{
                //         setVerifyLoading(false);
                //         let userData = {token, ...value[0]}
                //         setUser(userData);
                //         user.dispatch({type:types.SET_USER_DATA, userData});
                //         navigate("/");
                //     }
                // })
            },
            onError:(e)=>{
                setServerErr(e.response.data);
                // console.log(e);
                setVerifyLoading(false);
            }
        })
    }

    const fetchUser=(token)=>{
        contactEntity.fetch({
            token,
            filters:{contactid:"$contactId"},
            onResult:({data:{value}})=>{

                let userData = {token, ...value[0]}
                // console.log(userData)
                fetchAccount(userData);
            }
        })
    }

    const fetchAccount = (userData)=>{
        let fetchBody = `<fetch >
                          <entity name="contact">
                            <filter>
                              <condition attribute="contactid" operator="eq" value="{${userData.contactid}}" />
                            </filter>
                            <link-entity name="account" from="accountid" to="parentcustomerid" alias="Account">
                              <attribute name="name" alias="Name" />
                              <attribute name="accountid" alias="AccountId" />
                            </link-entity>
                          </entity>
                        </fetch>`;
        // console.log(fetchBody)
        contactEntity.fetch({
            token:userData.token,
            fetchBody,
            onResult:({data:{value}})=>{
                // console.log(value)
                if (value.length>0){
                    userData = {...userData, companies:value, account:value[0], customerid:value[0].AccountId}
                    fetchAccountChildren(userData, value[0].AccountId)
                }
                else {
                    setUser(userData);
                    user.dispatch({type:types.SET_USER_DATA, userData});
                    navigate("/");
                }

            },
            onError:(e)=>{
                // console.log(e)
            },
        })
    }

    const fetchAccountChildren = (userData, accountId)=>{
        let fetchBody = `<fetch >
                          <entity name="account">
                            <attribute name="name" alias="Name" />
                            <filter>
                              <condition attribute="parentaccountid" operator="eq" value="${accountId}" />
                            </filter>
                          </entity>
                        </fetch>`;

        accountEntity.fetch({
            token:userData.token,
            fetchBody,
            onResult:({data:{value}})=>{
                // console.log(value);
                userData = {...userData, companies:[...userData.companies, ...value]}
                // console.log(userData)
                setUser(userData);
                user.dispatch({type:types.SET_USER_DATA, userData});
                navigate("/");
            },
            onError:(e)=>{
                // console.log(e)
            },
        })
    }

    return(
        <div>
            <CardHeader/>
            <div className="flex flex-column justify-content-center align-items-center w-full p-6 lg:p-8">
                <div className="w-full flex flex-column gap-3">
                    <span className="font-bold">کد فعال سازی را وارد کنید</span>
                    <span className="text-xs">کد ۴ رقمی ارسال شده به شماره {mobileNumber} را وارد کنید</span>
                </div>
                <div className="flex flex-column justify-content-start w-full">

                    <div className="field">
                        <SingleCharInput onChange={(e)=>{e.length===4&&verify(e)}} />
                    </div>
                </div>
                <div className="flex flex-column gap-2 align-items-center w-full">
                    <Button className="w-full border-round-lg" loading={verifyLoading} label="دریافت کد فعال‌سازی" onClick={()=>{}}/>
                    <div className="flex justify-content-between align-items-center w-full text-xs">
                        <span>کد فعال‌سازی را دریافت نکردید؟</span>
                        <Button className="p-button-text text-xs" disabled={shomarandeh>0} onClick={()=>{requestCode(); setShomarandeh(60)}}>
                            <span>{retryText()}</span>
                        </Button>
                    </div>
                    <Button className="p-button-outlined border-round-lg white-space-nowrap p-button-sm text-xs flex gap-2" onClick={()=>{setCurrentComponent("LOGIN_PHONE_NUMBER")}}>
                        <Pencil/>
                        <span>تغییر شماره تلفن</span>
                    </Button>
                </div>
                <span className={`pt-3 ${serverErr && 'p-error block'}`}>{serverErr}</span>
            </div>
        </div>
    )
}

function Auth() {
    const [currentComponent, setCurrentComponent] = useState('LOGIN_PHONE_NUMBER');
    const [mobileNumber, setMobileNumber] = useState();
    const [showNotif, setShowNotif] = useState(true);
    const portalConfig = usePortalConfig();
    const [configData, setConfigData] = useState();

    const [operation, setOperation] = useState("LOGIN");
    const components = {
        LOGIN_PHONE_NUMBER : <LoginPhoneNumber operation={operation} setOperation={setOperation} mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} setCurrentComponent={setCurrentComponent}/>,
        VERIFY_CODE : <VerifyCode operation={operation} mobileNumber={mobileNumber} setCurrentComponent={setCurrentComponent}/>,
    }

    useEffect(()=>{
        portalConfig.get({
            onResult:(data)=>{
                setConfigData(data);
                setShowNotif(data.visible);
            }
        })
    },[])

    return (
        <>
            {
                showNotif && configData && (
                    <div>
                        <div className={`p-3 flex ${!configData.backgroundColor && "bg-primary"} text-sm w-full`} style={{backgroundColor:configData.backgroundColor, color:configData.textColor}}>
                            <i className="pi pi-times cursor-pointer p-1" onClick={()=>{setShowNotif(false)}}/>
                            <div className="pr-2 flex flex-column gap-1">

                                {configData.banner.map(({text, className})=>(<span className={className}>{text}</span>))}

                                {/*<ul>*/}
                                {/*    <li>نام ونام خانوادگی</li>*/}
                                {/*    <li>شماره موبایل</li>*/}
                                {/*    <li>ایمیل شرکتی</li>*/}
                                {/*</ul>*/}
                                {/*<span>نشانی ما: <a href="http://notification.kian-ph.com/" className="text-white" target="_blank">notification@kian-ph.com</a></span>*/}
                                {/*<span className="mt-3 font-bold"> * توجه داشته باشید پرتال قبلی کیان تا تاریخ 30 بهمن با آدرس <span className="font-bold bg-orange-400 p-1 border-round-lg cursor-pointer" onClick={()=>{window.open("https://rportal.kian-ph.com/")}}>rportal.kian-ph.com</span> فعال می باشد.</span>*/}
                            </div>
                        </div>

                    </div>
                )
            }
            <div className={`h-full w-full flex align-items-center justify-content-center ${config.glossary.dir}`}>
                <div className="w-full lg:w-10 flex flex-column h-full justify-content-evenly">
                    <div className="w-full flex align-items-center lg:flex-order-0 flex-1 p-3">
                        <div className="flex flex-column justify-content-center align-items-center w-full">
                            <div className="w-full lg:w-5 bg-white border-round-2xl shadow-3">
                                {
                                    components[currentComponent]
                                }
                            </div>
                            <div className="h-8rem flex align-items-end">
                                <img className="w-4rem" src={process.env.PUBLIC_URL+"/assets/images/logo3x.png"}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )

}

export default Auth;